const TEST_COLLECTIONS = ["DO NOT DEPLOY", "Test chart collection"];
//these two collections are not returned from the collections API:
export const DEFAULT_COLLECTIONS = [
  // { id: "Training Charts", name: "Training Charts", type: "training" },
  // { id: "Binance (live)", name: "Binance (live)", type: "binance" },
];

export const filterTestCollections = (list) => {
  return list.filter(
    (collection) =>
      //Remove test collections from list
      !TEST_COLLECTIONS.includes(collection.name)
  );
};
export const addCollectionType = (list) => {
  return list.map((collection) => {
    return { ...collection, type: "collection" };
  });
};
